import { CompoundButton, Button, Spinner, Text } from "@fluentui/react-components";
import { ContractAddendum } from "../../../../models/Entities/Contracts/ContractAddendum";
import moment from "moment";

import { Document24Regular, Edit16Regular, Delete16Regular, Handshake24Regular } from "@fluentui/react-icons";

// styles
import './Addendums.Styles.css';
import { use } from "i18next";
import { useEffect, useState } from "react";

import * as ComponentFunctions from './Addendums.Functions';
import { ContractAddendumType } from "../../../../models/Entities/Contracts/NewContractAddendum";



export interface AddendumItemProps {
    Addendum: ContractAddendum;
    SelectedAddendum: ContractAddendum | undefined;
    OnSelect: (addendum: ContractAddendum) => void;
    OnEdit?: (addendum: ContractAddendum) => void;
    OnDelete?: (addendum: ContractAddendum) => void;
    DeletingId?: number | undefined;
}

export const AddendumItemComponent = (props: AddendumItemProps) => {
    const [hovered, setHovered] = useState(false);

    const AddendumExpiricy = (props.Addendum?.contractAddendumExpiryStartDate || props.Addendum?.contractAddendumExpiryEndDate) ? (
        <Text style={{fontSize: '12px'}}>{props.Addendum?.contractAddendumExpiryStartDate ? moment(props.Addendum?.contractAddendumExpiryStartDate).format("DD/MM/YYYY") : 'No informado'} - {props.Addendum?.contractAddendumExpiryEndDate ? moment(props.Addendum?.contractAddendumExpiryEndDate).format("DD/MM/YYYY") : 'No informado'}</Text>
    ) : (
        <Text style={{fontSize: '12px'}}>Validity not defined</Text>
    );

    const isCurrent = ComponentFunctions.isCurrentAddendum(props.Addendum);
    const isExpired = ComponentFunctions.isExpiredAddendum(props.Addendum);
    const isPending = !isCurrent && !isExpired; 

    const statusClass = isPending
        ? 'addendum-item-pending'
        : props.Addendum.isActive
            ? 'addendum-item-active'
            : 'addendum-item-inactive';

    const stateBackgroundClass = isCurrent
        ? 'CurrentAddendum'
        : isExpired
            ? 'ExpiredAddendum'
            : isPending
                ? 'PendingAddendum'
                : '';

    const selectedClass = props.Addendum.id === props.SelectedAddendum?.id ? 'Active' : '';

    return (
        <CompoundButton
            id={`addendum-${props.Addendum.id}`}
            className={`${statusClass} ${stateBackgroundClass} ${selectedClass} AddendumButton ${props.Addendum.contractAddendumType === ContractAddendumType.NegociationInstance ? 'NegiciationAddendum' : '' }`.trim()}
            key={props.Addendum.id}
            appearance={props.Addendum.id === props.SelectedAddendum?.id ? "primary" : "secondary"}
            icon={props.Addendum.isGettingContractStages ? <Spinner appearance="inverted" size="small" /> : props.Addendum.contractAddendumType === ContractAddendumType.NegociationInstance ? <Handshake24Regular /> : <Document24Regular />}
            secondaryContent={AddendumExpiricy}
            onClick={() => props.OnSelect(props.Addendum)}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            {props.Addendum.contractAddendumName}
            {hovered && (
                <div className="AddendumFloatingActions">
                    <Button
                        appearance="subtle"
                        icon={<Edit16Regular />}
                        onClick={(e) => { e.stopPropagation(); props.OnEdit?.(props.Addendum); }}
                        title="Editar"
                    />
                    <Button
                        appearance="subtle"
                        icon={props.DeletingId === props.Addendum.id ? <Spinner size="extra-tiny" /> : <Delete16Regular />}
                        onClick={(e) => { e.stopPropagation(); props.OnDelete?.(props.Addendum); }}
                        title="Eliminar"
                    />
                </div>
            )}
        </CompoundButton>
    )
}